module.exports = __webpack_public_path__ + "img/lianxi.5775e062.png";